import GradientAvatar from '@/shared/components/GradientAvatar';
import { getAvatarInitials } from '@/shared/utils/string';
import React from 'react';

interface CanvasserAvatarProps {
  canvasserId: string;
  canvasserName: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * CanvasserAvatar Component
 *
 * A specialized wrapper around GradientAvatar for canvasser-specific use.
 * Generates a consistent, deterministic avatar gradient based on canvasser ID.
 */
const CanvasserAvatar: React.FC<CanvasserAvatarProps> = ({
  canvasserId,
  canvasserName,
  size = 'md',
  className,
}) => {
  // Get the initials from the canvasser name for display
  const displayInitials = getAvatarInitials(canvasserName || '');

  return (
    <GradientAvatar gradientKey={canvasserId} size={size} className={className}>
      {displayInitials}
    </GradientAvatar>
  );
};

export default CanvasserAvatar;
